// extracted by mini-css-extract-plugin
module.exports = {"imagePlaceholder":"styles_imagePlaceholder__Mu7FU"};